import { SORT_OPTIONS_ENUM } from 'src/constants'
import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

type remapSortOptionBetweenV1AndV2Props = {
  sortOption: string
  datedSearch: boolean
  isInGD128NovasolV2Exp: boolean
  brand: Brand
}

// See ADR [2025-11-17]-onesearch-PIM-migration-sort-order.md
export const remapSortOptionBetweenV1AndV2 = ({
  sortOption,
  datedSearch,
  isInGD128NovasolV2Exp,
  brand,
}: remapSortOptionBetweenV1AndV2Props): string => {
  if (isInGD128NovasolV2Exp) {
    if (!datedSearch) {
      if (sortOption === 'priceasc') {
        return SORT_OPTIONS_ENUM.RECOMMENDED
      }

      if (sortOption === 'pricedsc') {
        return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
      }
    }

    if (sortOption === 'bestmatch') {
      return SORT_OPTIONS_ENUM.RECOMMENDED
    }

    if (sortOption === 'gradedsc') {
      return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
    }

    return sortOption
  }

  // Novasol users NOT in V2 experiment, remap any V2 sort param to V1 compatible value
  if (brand === 'novasol') {
    if (sortOption === SORT_OPTIONS_ENUM.RECOMMENDED) {
      return 'bestmatch'
    }

    if (sortOption === SORT_OPTIONS_ENUM.REVIEWS_DESCENDING) {
      return 'gradedsc'
    }

    if (sortOption === SORT_OPTIONS_ENUM.SLEEPS_ASCENDING) {
      return 'priceasc'
    }

    if (sortOption === SORT_OPTIONS_ENUM.SLEEPS_DESCENDING) {
      return 'pricedsc'
    }

    if (sortOption === SORT_OPTIONS_ENUM.NO_SORT) {
      return 'bestmatch'
    }
  }
  return sortOption
}
